export const management = {
  routes: [
    {
      path: "/management/application-category",
      component: () => import("../management-library-application-category-view"),
    },
  ],
};
export const workspace = {
  routes: [
    {
      path: "/workspace/library/application-category",
      component: () => import("../workspace-library-application-category-view"),
    },
  ],
};

export const organization = {
  routes: [
    {
      path: "/organization/application",
      component: () => import("../application-view"),
    },
    {
      path: "/organization/application/:id",
      component: () => import("../application-view"),
    },
  ],
};

export const kvkk = {
  routes: [
    {
      path: "/kvkk/application",
      component: () => import("../application-view"),
    },
    {
      path: "/kvkk/application/:id",
      component: () => import("../application-view"),
    },
  ],
};

export const gdpr = {
  routes: [
    {
      path: "/gdpr/application",
      component: () => import("../application-view"),
    },
    {
      path: "/gdpr/application/:id",
      component: () => import("../application-view"),
    },
  ],
};
export const bgys = {
  routes: [
    {
      path: "/bgys/application",
      component: () => import("../application-view"),
    },
    {
      path: "/bgys/application/:id",
      component: () => import("../application-view"),
    },
  ],
};
export const ddo = {
  routes: [
    {
      path: "/ddo/application",
      component: () => import("../application-view"),
    },
    {
      path: "/ddo/application/:id",
      component: () => import("../application-view"),
    },
  ],
};
export const risk = {
  routes: [
    {
      path: "/risk/application",
      component: () => import("../application-view"),
    },
    {
      path: "/risk/application/:id",
      component: () => import("../application-view"),
    },
  ],
};
